import React, { Component } from 'react';
import { PanelHome } from '../../components';
import './Home.css';

export default class Home extends Component {
  render() {
    return (
      <div className="Home">
        <PanelHome />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HomeComponent/Home.js